var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,3.8H2.8l2.2-2.2c.3-.3.3-.8,0-1.1s-.8-.3-1.1,0L.5,4c0,0-.1.2-.2.2,0,0,0,.2,0,.3s0,.2,0,.3c0,0,0,.2.2.2l3.5,3.5c.1.1.3.2.5.2s.4,0,.5-.2c.3-.3.3-.8,0-1.1l-2.2-2.2h5.7c.4,0,.8-.3.8-.8s-.3-.8-.8-.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.8d699464764c77a29a77e0303b20ef4b.svg";
export { ForwardRef as ReactComponent };